import type { css } from 'styled-components';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';

export const SegmentButton = styled(ButtonBase)<{
  $customCss?: ReturnType<typeof css>;
}>`
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: var(--unit);
  padding: var(--half-unit) var(--unit);
  border-radius: var(--unit);
  box-shadow: inset 0px 0px 0px 1px var(--c-nd-100);
  ${({ $customCss }) => $customCss || ''}
  background: var(--c-black);

  &.checked {
    background: var(--c-white);
    color: var(--c-black);
  }

  &.disabled {
    opacity: 0.5;
  }
`;
